import { accountKey } from 'modules/global-wrapper';
import { IamState, Me } from 'types/iam';
import { RootState } from 'types/root';
import { Roles } from 'utils/constants';

export const iamDetailsTree = (state: RootState): IamState => state.iam || {};

export const meDetailsIsLoading = (state: RootState): boolean => iamDetailsTree(state).isLoading || false;

export const meDetails = (state: RootState): Me => iamDetailsTree(state).me || {};
export const userKey = (state: RootState): string => meDetails(state).key || '';
export const accounts = (state: RootState) => meDetails(state).accounts || [];
export const systemRoles = (state: RootState): string[] => meDetails(state).systemRoles || [];

export const isSystemUser = (state: RootState): boolean => systemRoles(state).includes(Roles.systemUser) || false;

export const childAccount = (state: RootState): { billingRoles?: string[] } => meDetails(state).childAccount || {};

export const effectiveBillingRoles = (state: RootState) => {
  const currentAccountKey = accountKey(state);
  const currentAccount = accounts(state).find((account) => account.key === currentAccountKey);
  if (currentAccount) {
    return currentAccount.billingRoles || [];
  } else if ((meDetails(state).systemRoles ?? []).includes(Roles.systemUser)) {
    return meDetails(state).sysBillingRoles || [];
  } else if (childAccount(state)) {
    return childAccount(state).billingRoles || [];
  }
};
